<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7.99995 14L7.99994 14.7502C7.99993 15.5786 7.32836 16.2501 6.49994 16.2501H5.25001C4.42158 16.2501 3.75 15.5786 3.75001 14.7501L3.75006 5.24999C3.75006 4.42157 4.42163 3.75 5.25006 3.75H6.49992C7.32834 3.75 7.99992 4.42157 7.99992 5.25V6" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M12.0001 14V14.7501C12.0001 15.5786 12.6717 16.2501 13.5001 16.2501H14.75C15.5784 16.2501 16.25 15.5786 16.25 14.7501L16.2499 5.24999C16.2499 4.42157 15.5784 3.75 14.7499 3.75H14.1249H13.5C12.6716 3.75 12 4.42157 12 5.25V6" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M13.25 8.99936L11.625 10.9998L8.375 9.00057L6.75 11.001" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ComparativeIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
